<mat-toolbar *ngIf="showToolbar" color="primary" class="flex items-center sticky top-0 z-[1000] shadow-md bg-white py-0 px-4">
  <!-- Logo -->
  <div class="flex items-center cursor-pointer py-5">
    <img src="assets/media/logos/maven-practice-app.svg" alt="Maven Practice App Logo" class="navbar-logo" />
  </div>

  <span class="flex-1"></span>

  <div class="user-details">
          <span  class="user-id">{{userName}}</span>
        </div>


  <mat-menu #userMenu="matMenu">
    <!-- <button mat-menu-item>
      <mat-icon>lock</mat-icon>
      <span>Change Password</span>
    </button> -->
    <button mat-menu-item disableRipple>
      <mat-icon>security</mat-icon>
      <span class="mr-auto">2FA</span>
      <mat-slide-toggle
        color="primary"
        [checked]="is2FAEnabled"
        (change)="toggle2FA($event)">
      </mat-slide-toggle>
    </button>

    <mat-divider></mat-divider>
    <button (click)="logout()" mat-menu-item>
      <mat-icon>logout</mat-icon>
      <span >Logout</span>
    </button>
  </mat-menu>
  <div class="flex items-center">
  <div>
    <!-- Button that opens the menu -->
    <button mat-button [matMenuTriggerFor]="userMenu">
      <mat-icon>account_circle</mat-icon>
    </button>
  </div>
</div>


</mat-toolbar>






<div class="form-container" [ngClass]="{ 'provider-margin-top': providerMode }"  #formContainer >
  <form (ngSubmit)="onSubmit()">
  <div class="form-header">

    <div class="progress-bar-to">
      <div *ngFor="let step of [1, 2, 3, 4]; let i = index" class="progress-step" [class.active]="currentStep === i + 1"
        (click)="goToStep(i + 1)" style="cursor: pointer">
        {{ step }}
      </div>
    </div>
  </div>

  
  <div *ngIf="currentStep === 1" >
    <!-- practice-information.component.html -->
<div  data-json-root="practice_info" >
    <div class="form-container" [formGroup]="practiceForm">


      <div [formGroup]="practiceForm">
        <!-- Practice Information -->
        <div class="form-section" >
          <div class="">
            <h2><mat-icon>business</mat-icon> Practice Information</h2>
            <div class="form-group input-with-icon">
              <label class="top-label">

                Practice Name <span class="required">*</span>
              </label>
              <input type="text" class="practice-input" formControlName="practiceName" placeholder="Enter practice name" data-json-path="practiceName"
                 />
            </div>

          </div>
        </div>

        <!-- Locations Form Array -->
        <div formArrayName="locations" id="location-container">
          <div *ngFor="let location of locations.controls; let i = index" [formGroupName]="i" class="location-block">
            <div class="practice-head">
  <h3>Location {{ i + 1 }}</h3>
  <button mat-icon-button color="warn" (click)="removeLocation(i)" [disabled]="locations.length <= 1">
    <mat-icon>delete</mat-icon>
  </button>
</div>
            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="input-icon">location_on</mat-icon>
                Address<span class="required">*</span>
              </label>

              <input matInput formControlName="address" placeholder="Address"
                [attr.data-json-path]="'locations['+i+'].address'">
                 <div class="error" *ngIf="location.get('address')?.errors?.required">Address is required</div>


              <!-- Row 1: 3 columns -->
<div class="form-row">
  <div class="form-group input-with-icon">
    <label class="top-label">
      <mat-icon class="input-icon" aria-hidden="true">location_city</mat-icon> 
      City <span class="required">*</span>
    </label>
    <input matInput formControlName="city" placeholder="City" [attr.data-json-path]="'locations['+i+'].city'"/>
    
  </div>

  <div class="form-group">
    <label class="top-label">
      <mat-icon class="input-icon" aria-hidden="true">location_on</mat-icon> 
      State/Province <span class="required">*</span>
    </label>
    <input matInput formControlName="state" placeholder="State" [attr.data-json-path]="'locations['+i+'].state'" />
   
  </div>

  <div class="form-group">
    <label class="top-label">
      <mat-icon class="input-icon" aria-hidden="true">badge</mat-icon> 
      Group NPI <span class="required">*</span>
    </label>
    <input matInput formControlName="groupNpi" placeholder="Group NPI" [attr.data-json-path]="'locations['+i+'].groupNpi'"/>
 
  </div>
</div>

<!-- Row 2: 2 columns -->
<div class="form-row">
  <div class="form-group">
    <label class="top-label">
      <mat-icon class="input-icon" aria-hidden="true">receipt_long</mat-icon> 
      Tax ID Number (TIN) <span class="required">*</span>
    </label>
    <input matInput formControlName="tin" placeholder="Enter TIN" [attr.data-json-path]="'locations['+i+'].tin'"/>
    <div class="error" *ngIf="location.get('Tax')?.errors?.required">Tax ID Number  is required</div>
  </div>

  <div class="form-group">
    <label class="top-label">
      <mat-icon class="input-icon" aria-hidden="true">markunread_mailbox</mat-icon> 
     ZIP / Postal Code
     <!-- <span class="required">*</span> -->
    </label>
    <input matInput formControlName="groupNpi" placeholder="ZIP / Postal Code" [attr.data-json-path]="'locations['+i+'].zip'"/>
    <!-- <div class="error" *ngIf="location.get('ZIP')?.errors?.required">ZIP / Postal Code is required</div> -->
  </div>
</div>



            </div>

            <!-- Practice Contacts -->

            <div class="">
              <div class="practice-head section-header">
                <h2>
                  <mat-icon class="heading-icon">contacts</mat-icon>
                  Practice Contact Information
                </h2>
                <button mat-raised-button color="primary" type="button" (click)="addPracticeContact(i)">
                  <mat-icon>add</mat-icon> Add Contact
                </button>
              </div>

              <div formArrayName="practiceContacts" class="card">
                <div *ngFor="let contact of getPracticeContacts(i).controls; let j = index" [formGroupName]="j"
                  class="contact-form-group">
                  <div class="actions-wrapper">
                    <button mat-icon-button color="warn" (click)="removePracticeContact(i, j)"
                      [disabled]="getPracticeContacts(i).controls.length <= 1" class="delete-btn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>

                  <div class="form-row">
                    <div class="form-group input-with-icon">
                      <label class="top-label">
                        <mat-icon class="label-icon">call</mat-icon> Phone 
                      </label>
                      <input type="tel" formControlName="phone" placeholder="(123) 456-7890" class="full-width-input" [attr.data-json-path]="'locations['+i+'].practice_contacts['+j+'].phone'"/>
                    </div>

                    <div class="form-group input-with-icon">
                      <label class="top-label">
                        <mat-icon class="label-icon">print</mat-icon> Fax
                      </label>
                      <input type="tel" formControlName="fax" placeholder="(123) 456-7890" class="full-width-input" [attr.data-json-path]="'locations['+i+'].practice_contacts['+j+'].fax'"/>
                    </div>

                    <div class="form-group input-with-icon">
                      <label class="top-label">
                        <mat-icon class="label-icon">email</mat-icon> Email
                      </label>
                      <input type="email" formControlName="email" placeholder="contact@example.com"
                        class="full-width-input"   [attr.data-json-path]="'locations['+i+'].practice_contacts['+j+'].email'"/>
                      <!-- <div class="error" *ngIf="getPracticeContacts(i).at(j).get('email')?.invalid">
                        Invalid email
                      </div> -->
                    </div>

                    <div class="form-group input-with-icon">
                      <label class="top-label">
                        <mat-icon class="label-icon">language</mat-icon> Website
                      </label>
                      <input type="url" formControlName="website" placeholder="https://example.com"
                        class="full-width-input"   [attr.data-json-path]="'locations['+i+'].practice_contacts['+j+'].website'"/>
                    </div>
                  </div>
                </div>

              </div>
              

            </div>


            <div class="form-section ">
  <div class="practice-head  section-header">
    <h2><mat-icon class="heading-icon">group</mat-icon> Employee Location Contacts</h2>
    <button mat-raised-button color="primary" type="button" (click)="addEmployeeContact(i)">
      <mat-icon>add</mat-icon> Add Employee
    </button>
  </div>

  <!-- <div *ngFor="let location of locations.controls; let i = index"> -->
    <div>
    <div formArrayName="employeeContacts"  class="card pt-0">
      <div
        class="form-row "
        *ngFor="let employee of getEmployeeContacts(i).controls; let k = index"
        [formGroupName]="k"
      >

          <button class="delete-btn" mat-icon-button color="warn" (click)="removeEmployeeContact(i, k)"
            [disabled]="getEmployeeContacts(i).controls.length <= 1">
            <mat-icon>delete</mat-icon>
          </button>
      
    
          
       
        <!-- Your form fields here -->
        <div class="form-group input-with-icon">
          <label class="top-label">
            <mat-icon class="label-icon">person</mat-icon> Name
          </label>
          <input
            type="text"
            formControlName="name"
            placeholder="Full name"
            class="full-width-input" [attr.data-json-path]="'locations['+i+'].employee_contacts['+k+'].name'"/>
        </div>
         <div class="form-group input-with-icon">
        <label class="top-label">
          <mat-icon class="label-icon">badge</mat-icon> Designation
        </label>
        <input
          type="text"
          formControlName="designation"
          placeholder="Designation"
          class="full-width-input" [attr.data-json-path]="'locations['+i+'].employee_contacts['+k+'].designation'"/>
        
      </div>


       <div class="form-group input-with-icon">
        <label class="top-label">
          <mat-icon class="label-icon">call</mat-icon> Phone
        </label>
        <input
          type="tel"
          formControlName="phone"
          placeholder="(123) 456-7890"
          class="full-width-input" [attr.data-json-path]="'locations['+i+'].employee_contacts['+k+'].phone'"/>
        
      </div>

      <div class="form-group input-with-icon">
        <label class="top-label">
          <mat-icon class="label-icon">smartphone</mat-icon> Mobile
        </label>
        <input
          type="tel"
          formControlName="mobile"
          placeholder="(123) 456-7890"
          class="full-width-input"  [attr.data-json-path]="'locations['+i+'].employee_contacts['+k+'].mobile'"/>
      
      </div>

       <div class="form-group input-with-icon">
        <label class="top-label">
          <mat-icon class="label-icon">email</mat-icon> Email
        </label>
        <input
          type="email"
          formControlName="email"
          placeholder="employee@example.com"
          class="full-width-input" [attr.data-json-path]="'locations['+i+'].employee_contacts['+k+'].email'"/>
       
       
      </div>

      

        
      </div>
    </div>
  </div>
</div>

          </div>
        </div>

        

        <div class="form-actions">
          <button mat-raised-button color="primary" type="button" (click)="addLocation()">
            <mat-icon>add_location</mat-icon> Add Location
          </button>
          <button mat-raised-button color="accent" type="button" (click)="nextStep()">
        Next <mat-icon>arrow_forward</mat-icon>
      </button>
        </div>
      </div>
    </div>
    </div>
  </div>
  <!-- Step 2: EHR System Information -->
  <div  class="form-container" data-json-root="ehr_system" *ngIf="currentStep === 2" >
    <div [formGroup]="ehrForm" novalidate>
    <div >
    <div class="form-section">
      <div class="section-header">
        <h2><mat-icon>laptop_medical</mat-icon> EHR System Details</h2>
      </div>

      <div class="form-group input-with-icon">
        <label class="top-label">
          <mat-icon class="label-icon">business</mat-icon>
          EHR System Name <span class="required">*</span>
        </label>
        <input type="text" formControlName="ehrName" placeholder="Enter EHR System Name" class="full-width-input"
          required />
        <div class="error" *ngIf="ehrForm.get('ehrName')?.hasError('required')">
          EHR System Name is required
        </div>
      </div>

    </div>

    <div class="form-section">
      <div class="section-header practice-head">
        <h2><mat-icon>headset</mat-icon> EHR Support Contact Information</h2>
        <button mat-raised-button color="primary" type="button" (click)="addSupportContact()">
          <mat-icon>add</mat-icon> Add Contact
        </button>
      </div>

      <div class="form-section">


        <div formArrayName="supportContacts" class="card">

          <div class="form-section" *ngFor="let contact of supportContacts.controls; let i = index" [formGroupName]="i">
            <div class=" actions-wrapper" style="margin-bottom: 0px;">

              <button class="delete-btn" mat-icon-button color="warn" (click)="removeSupportContact(i)"
                [disabled]="supportContacts.length <= 1">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <!-- Top Row: 3 Fields -->
            <div class="form-row">
              <div class="form-group input-with-icon">
                <label class="top-label">
                  <mat-icon class="label-icon">person</mat-icon> Support Contact Name
                </label>
                <input type="text" formControlName="contactName" placeholder="Contact name" class="full-width-input" [attr.data-json-path]="'supportContacts['+i+'].supportName'"/>
              </div>

              <div class="form-group input-with-icon">
                <label class="top-label">
                  <mat-icon class="label-icon">email</mat-icon> Email
                </label>
                <input type="email" formControlName="email" placeholder="contact@example.com"
                  class="full-width-input" [attr.data-json-path]="'supportContacts['+i+'].supportEmail'"/>
                <div class="error" *ngIf="supportContacts.at(i).get('email')?.hasError('email')">
                  Invalid email format
                </div>
              </div>

              <div class="form-group input-with-icon">
                <label class="top-label">
                  <mat-icon class="label-icon">call</mat-icon> Phone
                </label>
                <input type="tel" formControlName="phone" placeholder="(123) 456-7890" class="full-width-input" [attr.data-json-path]="'supportContacts['+i+'].supportPhone'" />
              </div>
            </div>

            <!-- Bottom Row: Website + Action -->
            <div class="form-row">
              <div class="form-group input-with-icon full-width">
                <label class="top-label">
                  <mat-icon class="label-icon">language</mat-icon> Support Website
                </label>
                <input type="url" formControlName="website" placeholder="https://support.com"
                  class="full-width-input"  [attr.data-json-path]="'supportContacts['+i+'].supportWebsite'"  />
              </div>


            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="form-section">
      <div class="section-header practice-head">
        <h2><mat-icon>lock</mat-icon> Username & Password</h2>
        <button mat-raised-button color="primary" type="button" (click)="addLoginCredential()">
          <mat-icon>add</mat-icon> Add Credential
        </button>
      </div>


      <div formArrayName="loginCredentials" class="card">
        <div class="form-section" *ngFor="let cred of loginCredentials.controls; let i = index" [formGroupName]="i">

          <div class="form-group action-group">

            <button class="delete-btn" mat-icon-button color="warn" (click)="removeLoginCredential(i)"
              [disabled]="loginCredentials.length <= 1">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <!-- Row 1 -->
          <div class="form-row">



            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">person</mat-icon> Username
              </label>
              <input type="text" formControlName="username" placeholder="Username" class="full-width-input"   [attr.data-json-path]="'loginCredentials['+i+'].username'">
            </div>

            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">vpn_key</mat-icon> Password
              </label>
              <input type="password" formControlName="password" placeholder="Password" class="full-width-input" [attr.data-json-path]="'loginCredentials['+i+'].password'" />
            </div>

            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">admin_panel_settings</mat-icon> Access Level
              </label>
              <select formControlName="accessLevel" class="full-width-input" [attr.data-json-path]="'loginCredentials['+i+'].accessLevel'" >
                <option value="admin">Admin</option>
                <option value="user">User</option>
                <option value="viewer">Viewer</option>
              </select>
            </div>

          </div>

          <!-- Row 2 -->
          <div class="form-row">
            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">security</mat-icon> Security Q&A
              </label>
              <input type="text" formControlName="securityQA" placeholder="Security answer" class="full-width-input" [attr.data-json-path]="'loginCredentials['+i+'].securityQA'" />
            </div>

            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">email</mat-icon> Forgot Email
              </label>
              <input type="email" formControlName="forgotEmail" placeholder="recovery@email.com"
                class="full-width-input" [attr.data-json-path]="'loginCredentials['+i+'].forgetEmail'" />
              <div class="error" *ngIf="loginCredentials.at(i).get('forgotEmail')?.hasError('email')">
                Invalid email format
              </div>
            </div>

            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">smartphone</mat-icon> Mobile OTP
              </label>
              <input type="tel" formControlName="mobileOTP" placeholder="(123) 456-7890" class="full-width-input"  [attr.data-json-path]="'loginCredentials['+i+'].otpNumber'" />
            </div>
          </div>

          <!-- Row 3 -->
          <div class="form-row">

            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">link</mat-icon> Login Link
              </label>
              <input type="url" formControlName="loginLink" placeholder="https://login.com" class="full-width-input"  [attr.data-json-path]="'loginCredentials['+i+'].loginLink'" />
            </div>




          </div>
        </div>
      </div>



    </div>

    <div class="form-actions">
      <button mat-raised-button color="primary" type="button" (click)="prevStep()">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
      <button mat-raised-button color="accent" type="button" (click)="nextStep()">
        Next <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
    </div>
    </div>
  </div>

  <!-- Step 3: Clearinghouse Information -->

  <div class="form-container" data-json-root="clearing_house"  *ngIf="currentStep === 3" >
    <div  >
   <div [formGroup]="clearinghouseForm" novalidate>
      <div class="form-section" >


        <div class="section-header practice-head">
          <h2><mat-icon>sync_alt</mat-icon> Clearinghouse Details</h2>
          <div class=" ">

            <button mat-raised-button color="primary" type="button" (click)="addClearinghouseName()">
              <mat-icon>add</mat-icon> Clearinghouse Name 
            </button>
          </div>


        </div>





        <div formArrayName="clearinghouseNames" class="card">
          <div *ngFor="let group of clearinghouseNames.controls; let i = index" [formGroupName]="i"  >
            <div class="form-row" style="margin-bottom: 0px; padding: 0px;">
              <button class="delete-btn" mat-icon-button color="warn" (click)="removeClearinghouseName(i)"
                [disabled]="clearinghouseNames.length <= 1">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">business</mat-icon>
                Clearinghouse Name <span class="required">*</span>
              </label>

              <input matInput formControlName="name" placeholder="e.g., Tebra, Office Ally" required  data-json-path="clearinghouseName"/>
              <div class="error"  *ngIf="group.get('name')?.hasError('required')">
                Clearinghouse name is required
              </div>

            </div>
            <div class="form-group input-with-icon">
              <label class="top-label">
                <mat-icon class="label-icon">language</mat-icon>
                Website <span class="required">*</span>
              </label>
              <input type="text" class="full-width-input" formControlName="name" placeholder="https://example.com"  data-json-path="clearinghouseWebsite"
                required />

            </div>
          </div>

        </div>


      </div>




      <div class="form-section ">
        <div class="section-header practice-head">
          <h2><mat-icon>vpn_key</mat-icon> Clearinghouse Credentials</h2>
          <button mat-raised-button color="primary" type="button" (click)="addCredential()">
            <mat-icon>add</mat-icon> Add Credential
          </button>
        </div>

        <div class="form-section">


          <div formArrayName="credentials" class="card">
            <div class="form-row" *ngFor="let cred of credentials.controls; let i = index" [formGroupName]="i">

             

                <button class="delete-btn" mat-icon-button color="warn" (click)="removeCredential(i)"
                  [disabled]="credentials.length <= 1">
                  <mat-icon>delete</mat-icon>
                </button>
             
              <div class="top-row">
                <div class="form-group">
                  <label class="top-label"><mat-icon class="label-icon">person</mat-icon> Username</label>
                  <input type="text" formControlName="username" placeholder="Username" class="full-width-input" [attr.data-json-path]="'credentials['+i+'].chUsername'" />
                </div>

                <div class="form-group">
                  <label class="top-label"><mat-icon class="label-icon">lock</mat-icon> Password</label>
                  <input type="password" formControlName="password" placeholder="Password" class="full-width-input" [attr.data-json-path]="'credentials['+i+'].chPassword'" />
                </div>

                <div class="form-group">
                  <label class="top-label"><mat-icon class="label-icon">security</mat-icon> Security Q&A</label>
                  <input type="text" formControlName="securityQA" placeholder="Security question"  [attr.data-json-path]="'credentials['+i+'].chSecurityQA'"
                    class="full-width-input" />
                </div>
              </div>

              <!-- Bottom row: Mobile OTP, Forgot Email, Access Level + Delete Button -->
              <div class="bottom-row">
                <div class="form-group">
                  <label class="top-label"><mat-icon class="label-icon">smartphone</mat-icon> Mobile OTP</label>
                  <input type="tel" formControlName="mobileOTP" placeholder="(123) 456-7890" class="full-width-input"  [attr.data-json-path]="'credentials['+i+'].chMobileOTP'" />
                </div>

                <div class="form-group">
                  <label class="top-label"><mat-icon class="label-icon">email</mat-icon> Forgot Password Email</label>
                  <input type="email" formControlName="forgotEmail" placeholder="recovery@email.com"   [attr.data-json-path]="'credentials['+i+'].chForgetEmail'"
                    class="full-width-input" />
                  <div class="error" *ngIf="credentials.at(i).get('forgotEmail')?.hasError('email')">
                    Invalid email
                  </div>
                </div>

                <div class="form-group action-group">
                  <label class="top-label"><mat-icon class="label-icon">admin_panel_settings</mat-icon> Access
                    Level</label>
                  <select formControlName="accessLevel" class="full-width-input"   [attr.data-json-path]="'credentials['+i+'].chAccessLevel'">
                    <option value="admin">Admin</option>
                    <option value="user">User</option>
                    <option value="viewer">Viewer</option>
                  </select>
                </div>


              </div>
            </div>
          </div>
        </div>

      </div>



    <div class="form-actions">
      <button mat-raised-button color="primary" type="button" (click)="prevStep()">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
      <button mat-raised-button color="accent" type="button" (click)="nextStep()">
      Next <mat-icon>arrow_forward</mat-icon>
    </button>
    </div>

    </div>
    </div>
  </div>

  <!-- Step 4: Payor & Provider -->

  <div class="form-container" *ngIf="currentStep === 4">
    <div data-json-root="payor_and_providers">
    <!-- Payor Information Form -->
    <div [formGroup]="payorForm" novalidate>
      <!-- Payor Information Section -->
      <div class="form-section" >
        <div class="section-header practice-head">
          <h2><mat-icon>payments</mat-icon> Payor Information</h2>
          <button mat-raised-button type="button" color="primary" (click)="addPayorLogin()">
            <mat-icon>add</mat-icon> Add Payor
          </button>
        </div>

        <div formArrayName="payorLogins" class="card">
          <div *ngFor="let login of payorLogins.controls; let i = index" [formGroupName]="i"
            class="payor-login-card">
            <div class="action-group" style="margin-bottom: 0px;">
  <button class="delete-btn" 
          mat-icon-button 
          color="warn" 
          (click)="removePayorLogin(i)" 
          type="button"
          [disabled]="payorLogins.controls.length <= 1">
    <mat-icon>delete</mat-icon>
  </button>
</div>

            <!-- Top Row -->
            <div class="form-row top-row">
              <div class="form-group">
                <label class="top-label">
                  <mat-icon class="label-icon">business</mat-icon> Payor Name <span class="required">*</span>
                </label>
                <input class="full-width-input" type="text" formControlName="payorName" placeholder="Payor Name"  [attr.data-json-path]="'payors['+i+'].payorName'"/>
              </div>

              <div class="form-group">
                <label class="top-label">
                  <mat-icon class="label-icon">public</mat-icon> Website Link <span class="required">*</span>
                </label>
                <input class="full-width-input" type="url" formControlName="websiteLink"
                  placeholder="https://example.com"  [attr.data-json-path]="'payors['+i+'].website'"    />
              </div>

              <div class="form-group">
                <label class="top-label">
                  <mat-icon class="label-icon">person</mat-icon> Username <span class="required">*</span>
                </label>
                <input class="full-width-input" type="text" formControlName="username" placeholder="Username" [attr.data-json-path]="'payors['+i+'].username'" />
              </div>
            </div>

            <!-- Bottom Row -->
            <div class="form-row bottom-row">
              <div class="form-group">
                <label class="top-label">
                  <mat-icon class="label-icon">vpn_key</mat-icon> Password <span class="required">*</span>
                </label>
                <input class="full-width-input" type="password" formControlName="password" placeholder="Password" [attr.data-json-path]="'payors['+i+'].password'" />
              </div>

              <div class="form-group">
                <label class="top-label">
                  <mat-icon class="label-icon">security</mat-icon> Security Q & A
                </label>
                <input class="full-width-input" type="text" formControlName="securityQA" placeholder="Security Info"  [attr.data-json-path]="'payors['+i+'].securityQA'" />
              </div>

              <div class="form-group">
                <label class="top-label">
                  <mat-icon class="label-icon">email</mat-icon> Email <span class="required">*</span>
                </label>
                <input class="full-width-input" type="email" formControlName="email" placeholder="email@example.com" [attr.data-json-path]="'payors['+i+'].email'" />
              </div>

              <div class="form-group">
                <label class="top-label">
                  <mat-icon class="label-icon">smartphone</mat-icon> Mobile <span class="required">*</span>
                </label>
                <input class="full-width-input" type="tel" formControlName="mobile" placeholder="1234567890" [attr.data-json-path]="'payors['+i+'].mobile'" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="section-header practice-head">
          <h2><mat-icon>info</mat-icon> Other Payor Information</h2>
        </div>
        <div class="full-width">
          <textarea matInput formControlName="otherPayorInfo" rows="4" class="full-width-input" data-json-path="other_payor_info"
            placeholder="Enter any additional payor information"></textarea>
        </div>
      </div>

   

    <!-- Provider Information Form (Separate form) -->
    <div  [formGroup]="providerForm"  novalidate>
      <mat-divider class="section-divider"></mat-divider>

      <div class="form-section">
        <div class="section-header practice-head">
          <h2><mat-icon>medical_services</mat-icon> Provider Information</h2>
           <button mat-raised-button color="primary" type="button" (click)="addProviderSection()">
                <mat-icon>add</mat-icon> Add Another Provider
              </button>
        </div>

        <div formArrayName="providers" class="card">
          <div *ngFor="let provider of providerFormProviders.controls; let i = index" [formGroupName]="i"
            class="provi">
            <div class="provider-header delete-btn-upload">
  <h3>Provider {{i + 1}}</h3>
  <button mat-icon-button 
          color="warn" 
          (click)="removeProviderSection(i)"
          [disabled]="providerFormProviders.controls.length <= 1"
          matTooltip="Remove provider">
    <mat-icon>delete</mat-icon>
  </button>
</div>  

            <div class="form-grid-2x3">
              <!-- Row 1 -->
              <div class="form-group input-with-icon">
                <label class="top-label">Title </label>
                <select formControlName="title" class="full-width-input" required>
                  <option value="">Select Title</option>
                  <option value="Dr.">Dr.</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Ms.">Ms.</option>
                </select>
              </div>

              <div class="form-group input-with-icon">
                <label class="top-label">First Name </label>
                <input type="text" formControlName="firstName" class="full-width-input" required  [attr.data-json-path]="'providers['+i+'].providerName'" />
              
              </div>

              <div class="form-group input-with-icon">
                <label class="top-label">Last Name </label>
                <input type="text" formControlName="lastName" class="full-width-input" required />
              
              </div>

              <!-- Row 2 -->
              <div class="form-group input-with-icon">
                <label class="top-label">Credential </label>
                <input type="text" formControlName="credential" class="full-width-input" required />

              </div>

              <div class="form-group input-with-icon">
                <label class="top-label">NPI # </label>
                <input type="text" formControlName="npi" class="full-width-input" required   [attr.data-json-path]="'providers['+i+'].npi'" />
   
              </div>


            </div>
<!-- 
            <div class="file-upload-grid">
  <div class="upload-card" *ngFor="let type of fileTypes">
    <h4>
      <mat-icon class="type-icon">{{ type.icon }}</mat-icon>
      {{ type.label }}
      <span class="file-limit">(Max 10 files)</span>
    </h4>

    <label class="dropzone">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <span>Drag & drop files here or click to browse</span>
      <input
        type="file"
        hidden
        multiple
        (change)="onFileChange($event, type.name, i)" 
        [attr.data-json-path]="'providers[' + i + '].' + type.name + 'Files[]'"
        [attr.data-doc-type]="type.name + 'Files'"
        [attr.data-provider-index]="i"
      />
    </label>

    <div *ngIf="uploadedFiles[type.name]?.length > 0" class="uploaded-list">
      <p *ngFor="let file of uploadedFiles[type.name]">{{ file.name }}</p>
    </div>
  </div>
</div> -->

<div class="file-upload-grid">
  <div class="upload-card" *ngFor="let type of fileTypes">
    <h4>
      <mat-icon class="type-icon">{{ type.icon }}</mat-icon>
      {{ type.label }}
      <span class="file-limit">(Max 10 files)</span>
    </h4>

    <label class="dropzone">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <span>Drag & drop files here or click to browse</span>
      <input
        type="file"
        hidden
        multiple
        (change)="onFileChange($event, type.name, i)"
        [attr.data-json-path]="'providers[' + i + '].' + type.name + 'Files[]'"
        [attr.data-doc-type]="type.name + 'Files'"
        [attr.data-provider-index]="i"
      />
    </label>

    <div *ngIf="getUploadedFiles(type.name, i)?.length > 0" class="uploaded-list">
      <div *ngFor="let file of getUploadedFiles(type.name, i)" class="uploaded-file">
        <mat-icon>insert_drive_file</mat-icon>
        <span><a [href]="file.googleDriveLink" target="_blank">{{ file.name }}</a></span>
        <button mat-icon-button (click)="removeFile(type.name, i, file)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>





           
          </div>
        </div>


      </div>

      <div class="form-actions">
        <button mat-raised-button color="primary" type="button" (click)="prevStep()">
          <mat-icon>arrow_back</mat-icon> Back
        </button>
        <button mat-raised-button color="primary" type="submit" [disabled]="isSubmitting">
    <mat-icon>check</mat-icon> 
    {{ isSubmitting ? 'Submitting...' : 'Submit' }}
  </button>
        
      </div>
    </div>
  </div>
     </div>
     
  </div>

  <!-- <form [formGroup]="payorForm" *ngIf="currentStep === 4" (ngSubmit)="submitAll()" novalidate>


 <form [formGroup]="clearinghouseForm" (ngSubmit)="onSubmit()">
    <div class="form-section">
      <div class="section-header">
        <h2><mat-icon>payments</mat-icon> Payor Information</h2>
      </div>
       <button mat-raised-button type="button" color="primary" (click)="addPayorLogin()">
          <mat-icon>add</mat-icon> Add Payor
        </button>

      

    </div>

    <div class="form-section">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th><mat-icon>business</mat-icon> Payor Name</th>
              <th><mat-icon>public</mat-icon> Website Link</th>
              <th><mat-icon>person</mat-icon> Username</th>
              <th><mat-icon>vpn_key</mat-icon> Password</th>
              <th><mat-icon>security</mat-icon> Security Q & A</th>
              <th><mat-icon>email</mat-icon> Email ID</th>
              <th><mat-icon>smartphone</mat-icon> Mobile #</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody formArrayName="credentials">
            <tr *ngFor="let login of payorLogins.controls; let i = index" [formGroupName]="i">
              <td>
                <mat-form-field>
                  <input matInput formControlName="payorName" placeholder="Payor Name" required>
                  <mat-error *ngIf="payorLogins.at(i).get('payorName')?.invalid">Required</mat-error>
                </mat-form-field>
              </td>
             <td>
                <mat-form-field>
                  <input matInput formControlName="websiteLink" placeholder="https://example.com" required>
                  <mat-error *ngIf="payorLogins.at(i).get('websiteLink')?.invalid">Valid URL required</mat-error>
                </mat-form-field>
              </td>
               <td>
                <mat-form-field>
                  <input matInput formControlName="username" placeholder="Username" required>
                  <mat-error *ngIf="payorLogins.at(i).get('username')?.invalid">Required</mat-error>
                </mat-form-field>
              </td>
             <td>
                <mat-form-field>
                  <input matInput type="password" formControlName="password" placeholder="Password" required>
                  <mat-error *ngIf="payorLogins.at(i).get('password')?.invalid">Required</mat-error>
                </mat-form-field>
              </td>
               <td>
                <mat-form-field>
                  <input matInput formControlName="securityQA" placeholder="Security Info">
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input matInput type="email" formControlName="email" placeholder="email@example.com" required>
                  <mat-error *ngIf="payorLogins.at(i).get('email')?.invalid">Valid email required</mat-error>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input matInput formControlName="mobile" placeholder="1234567890" required>
                  <mat-error *ngIf="payorLogins.at(i).get('mobile')?.invalid">10 digits required</mat-error>
                </mat-form-field>
              </td>
               <td>
                <button mat-icon-button color="warn" (click)="removePayorLogin(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
 <div class="form-row">
            <mat-form-field>
              <mat-label>First Name</mat-label>
              <input matInput formControlName="providerFirstName" required>
              <mat-error>Required</mat-error>
            </mat-form-field>
            
            <mat-form-field>
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="providerLastName" required>
              <mat-error>Required</mat-error>
            </mat-form-field>
          </div>
    
  </form>


    
    <div class="form-actions">
      <button mat-raised-button color="primary" type="button" (click)="prevStep()">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
      <button mat-raised-button color="primary" type="submit">
        Submit <mat-icon>check</mat-icon>
      </button>
    </div>
  </form> -->
  </form>
</div>